module.exports = __webpack_public_path__ + "img/butterfly-card.90a2db37.svg";